import script from "./UpdateItem.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateItem.vue?vue&type=script&setup=true&lang=js"

import "./UpdateItem.vue?vue&type=style&index=0&id=4d1e3c8c&lang=scss"

const __exports__ = script;

export default __exports__